import { render, staticRenderFns } from "./PersistOcorrenciaTrackingResponsavelView.vue?vue&type=template&id=0bd0d646&"
import script from "./PersistOcorrenciaTrackingResponsavelView.vue?vue&type=script&lang=ts&"
export * from "./PersistOcorrenciaTrackingResponsavelView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports